/*
  Mustlovegifts: verplichte personalisatie.
  Productpagina: Add to cart blijft vergrendeld tot Printify een opgeslagen ontwerp meldt.
  Cart: checkout op slot zolang er een regel zonder personalisatie in staat.
  Alleen actief op producten met de tag "personalized" (window.MLG_PERSONALIZATION_LOCK).
*/
(function () {
  'use strict';

  var PROP_NAME = 'Personalization ID';
  var LOCK_MESSAGE = "Make it theirs first. Personalize it above and it's ready for the cart.";
  var SAVED_TEXT = /remove saved design/i;

  /* ---------- Productpagina ---------- */

  function hasSavedDesign() {
    // Signaal 1: Printify zet het personalisatie-ID als property in het formulier.
    var inputs = document.querySelectorAll('input[name*="' + PROP_NAME + '"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value && inputs[i].value.trim() !== '') return true;
    }
    // Signaal 2: de Printify-knop toont "Remove saved design".
    var candidates = document.querySelectorAll('button, a, [role="button"]');
    for (var j = 0; j < candidates.length; j++) {
      var el = candidates[j];
      if (SAVED_TEXT.test(el.textContent || '') && el.offsetParent !== null) return true;
    }
    return false;
  }

  function addButtons() {
    return document.querySelectorAll('form[action*="/cart/add"] button[name="add"]');
  }

  function ensureMessage(button) {
    var host = button.closest('add-to-cart-component') || button;
    var next = host.nextElementSibling;
    if (next && next.classList.contains('mlg-lock-message')) return next;
    var msg = document.createElement('p');
    msg.className = 'mlg-lock-message';
    msg.id = 'mlg-lock-message';
    msg.setAttribute('role', 'status');
    msg.setAttribute('aria-live', 'polite');
    msg.hidden = true;
    msg.textContent = LOCK_MESSAGE;
    host.insertAdjacentElement('afterend', msg);
    return msg;
  }

  function applyProductLock() {
    var locked = !hasSavedDesign();
    addButtons().forEach(function (button) {
      var msg = ensureMessage(button);
      if (locked) {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-describedby', 'mlg-lock-message');
        button.classList.add('mlg-locked');
        button.classList.remove('mlg-unlocked');
      } else {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('aria-describedby');
        button.classList.remove('mlg-locked');
        button.classList.add('mlg-unlocked');
        msg.hidden = true;
      }
    });
  }

  function blockIfLocked(event) {
    var target = event.target;
    var button = null;
    var form = null;
    if (event.type === 'submit') {
      form = target.closest ? target.closest('form[action*="/cart/add"]') : null;
      if (!form) return;
      button = form.querySelector('button[name="add"]');
    } else {
      button = target.closest ? target.closest('form[action*="/cart/add"] button[name="add"]') : null;
    }
    if (!button) return;
    if (hasSavedDesign()) {
      applyProductLock();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    applyProductLock();
    var msg = ensureMessage(button);
    msg.hidden = false;
    var personalize = document.querySelector('[id*="printify"] button, [class*="printify"] button');
    if (personalize && typeof personalize.scrollIntoView === 'function') {
      personalize.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function initProduct() {
    applyProductLock();
    document.addEventListener('click', blockIfLocked, true);
    document.addEventListener('submit', blockIfLocked, true);
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        applyProductLock();
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    // Printify kan een hidden input vullen zonder DOM-mutatie: daarom ook periodiek controleren.
    setInterval(applyProductLock, 700);
  }

  /* ---------- Cart en cartdrawer ---------- */

  var ROW_WARNING = 'Not personalized yet. Remove this item, add their name on the product page, save your design and add it again.';
  var CHECKOUT_NOTE = "One of your gifts isn't personalized yet. Remove it and add it again after saving your design to check out.";
  var tagCache = {};
  var flaggedKeys = [];
  var lastSignature = null;

  function productIsPersonalized(handle) {
    if (tagCache[handle] !== undefined) return Promise.resolve(tagCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
      .then(function (p) {
        var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
        tagCache[handle] = tags.indexOf('personalized') !== -1;
        return tagCache[handle];
      })
      .catch(function () { return false; });
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var checks = (cart.items || []).map(function (item) {
          var props = item.properties || {};
          var id = props[PROP_NAME];
          if (id && String(id).trim() !== '') return Promise.resolve(null);
          return productIsPersonalized(item.handle).then(function (isPers) { return isPers ? item.key : null; });
        });
        return Promise.all(checks);
      })
      .then(function (keys) {
        flaggedKeys = keys.filter(Boolean);
        applyCartGuard();
      })
      .catch(function () {});
  }

  function markRows() {
    document.querySelectorAll('tr[data-key]').forEach(function (row) {
      var flagged = flaggedKeys.indexOf(row.getAttribute('data-key')) !== -1;
      var existing = row.querySelector('.mlg-cart-warning');
      if (flagged && !existing) {
        var target = row.querySelector('.cart-items__product-info') || row.querySelector('.cart-items__details');
        if (target) {
          var p = document.createElement('p');
          p.className = 'mlg-cart-warning';
          p.textContent = ROW_WARNING;
          target.appendChild(p);
        }
      } else if (!flagged && existing) {
        existing.remove();
      }
    });
  }

  function applyCartGuard() {
    markRows();
    var missing = flaggedKeys.length > 0;
    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
      var note = btn.parentElement ? btn.parentElement.querySelector('.mlg-checkout-note') : null;
      if (missing) {
        btn.disabled = true;
        btn.classList.add('mlg-checkout-locked');
        if (!note) {
          note = document.createElement('p');
          note.className = 'mlg-checkout-note';
          note.setAttribute('role', 'status');
          note.textContent = CHECKOUT_NOTE;
          btn.insertAdjacentElement('beforebegin', note);
        }
      } else {
        if (btn.classList.contains('mlg-checkout-locked')) {
          btn.disabled = false;
          btn.classList.remove('mlg-checkout-locked');
        }
        if (note) note.remove();
      }
    });
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (el) {
      el.hidden = missing;
    });
  }

  function cartSignature() {
    var keys = [];
    document.querySelectorAll('tr[data-key]').forEach(function (row) { keys.push(row.getAttribute('data-key')); });
    return keys.join('|');
  }

  function initCart() {
    refreshCart();
    document.addEventListener('cart:update', function () { setTimeout(refreshCart, 150); });
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var sig = cartSignature();
        if (sig !== lastSignature) {
          lastSignature = sig;
          refreshCart();
        } else {
          applyCartGuard();
        }
      }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function productHandleFromUrl() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function init() {
    initCart();
    if (window.MLG_PERSONALIZATION_LOCK) {
      initProduct();
      return;
    }
    // Vangnet: bepaal de tag zelf als de Liquid-vlag ontbreekt.
    var handle = productHandleFromUrl();
    if (!handle) return;
    productIsPersonalized(handle).then(function (isPers) {
      if (isPers) initProduct();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
